import React, { useEffect, useState } from "react";
import Login from "../login/Login.page";
import {
  Box,
  Button,
  Chip,
  Divider,
  Grid,
  Grid2,
  Tooltip,
  Typography,
} from "@mui/material";
import { ThemeColor } from "../../component/theme/color";
import { fontSize } from "../../component/theme/fontSize";
import { fontWeight } from "../../component/theme/fontWeight";
import { PromotedUniversityService } from "../../Redux/service/SettingService";
import { GetPromotedUniversityAction } from "../../Redux/action/SettingAction";
import { useDispatch, useSelector } from "react-redux";
import { FontFamily } from "../../component/theme/fontFamily";
import {
  convertFromHTML,
  ContentState,
  EditorState,
  convertFromRaw,
} from "draft-js";

import { Editor } from "react-draft-wysiwyg";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

function UniversityCard() {
  const dispatch = useDispatch();
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );

  const [PromotedUniversity, setPromotedUniversity] = useState([]);
  const [search, setSearch] = useState("");
  const PromotedUniversityState = useSelector(
    (state) => state.setting?.PromotedUniversity?.data?.universities
  );
  const getPlainText = (rawDescription) => {
    if (!rawDescription) return "";
    try {
      const content = convertFromRaw(JSON.parse(rawDescription));
      return content.getPlainText(); // Plain text from Editor content
    } catch (err) {
      return ""; // Fallback in case of bad input
    }
  };

  // const plainText = getPlainText(data?.description);
  // const truncatedText =
  //   plainText.length > 400 ? plainText.slice(0, 400) + "..." : plainText;

  const getInitials = (name) => {
    return name?.trim().charAt(0).toUpperCase() || "";
  };
  useEffect(() => {
    dispatch(GetPromotedUniversityAction());
  }, []);

  useEffect(() => {
    setPromotedUniversity(PromotedUniversityState);
  }, [PromotedUniversityState]);

  const Description = (description) => {
    if (description) {
      //   const blocksFromHTML = convertFromHTML(description);
      //   const contentState = ContentState.createFromBlockArray(
      //     blocksFromHTML.contentBlocks,
      //     blocksFromHTML.entityMap
      //   );
      //   const newEditorState = EditorState.createWithContent(contentState);
      //   return newEditorState;
      //   // setEditorState(newEditorState);/
      // }

        const contentBlock = htmlToDraft(description);
        if (contentBlock) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock.contentBlocks,
            contentBlock.entityMap
          );
          const newEditorState = EditorState.createWithContent(contentState);
          return newEditorState;
          // setEditorState(newEditorState);
        }
    }
  };

  // Filter PromotedUniversity
  const filteredUniversities = PromotedUniversity?.filter((university) => {
    const searchLower = search.toLowerCase();
    return (
      university.name.toLowerCase().includes(searchLower) ||
      university.country.toLowerCase().includes(searchLower) ||
      university.state.toLowerCase().includes(searchLower)
    );
  });

  return (
    <Login>
      <Box
        className="w-100 mt-5"
        sx={{ padding: { lg: 5, xs: 0 }, height: "100vh", overflowY: "scroll" }}
      >
        <input
          type="text"
          placeholder="Search university by name, country or state"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ padding: "8px", width: "100%", marginBottom: "20px" }}
        />
        <Grid container spacing={2}>
          {filteredUniversities?.map((data) => {
            return (
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <Box
                  sx={{
                    border: `2px solid ${ThemeColor.GREY}`,
                    borderRadius: "15px",
                    height: { lg: "450px", sm: "450px" },
                    px: 2,
                    pb: 2,
                    // overflowY: 'scroll',
                  }}
                >
                  {data?.logo ? (
                    <Grid2 container sx={{ height: "30%" }}>
                      <Grid2 size={8}>
                        <Typography
                          className="mt-4"
                          fontSize={fontSize.h3.large}
                          color={ThemeColor.NAVYBLUE}
                          fontWeight={fontWeight.W500}
                        >
                          {data.name}
                        </Typography>
                        <Typography
                          className="mt-2"
                          fontFamily={FontFamily.Lato}
                          fontSize={fontSize.h3.small}
                          fontWeight={fontWeight.W400}
                        >
                          {data?.country} {data?.state},{data?.city}
                        </Typography>
                        {data?.isFever === "Y" && (
                          <div className="mt-1">
                            <Chip
                              label="Fee Waiver"
                              size="small"
                              sx={{
                                background: "rgba(210, 4, 45,0.8)",
                                color: "white",
                              }}
                            />
                          </div>
                        )}
                      </Grid2>
                      <Grid2 size={4}>
                        <div className="d-flex align-items-center justify-content-center w-100 h-100">
                          <div style={{ width: "100px", height: "100px" }}>
                            <img
                              src={data.logo}
                              alt="logo"
                              className="w-100 h-100"
                            ></img>
                          </div>
                        </div>
                      </Grid2>
                    </Grid2>
                  ) : (
                    <Grid2 container sx={{ height: "30%" }}>
                      <Grid2 size={8}>
                        <Typography
                          className="mt-4"
                          fontSize={fontSize.h3.large}
                          color={ThemeColor.NAVYBLUE}
                          fontWeight={fontWeight.W500}
                        >
                          {data.name}
                        </Typography>
                        <Typography
                          className="mt-2"
                          fontFamily={FontFamily.Lato}
                          fontSize={fontSize.h3.small}
                          fontWeight={fontWeight.W400}
                        >
                          {data?.country} {data?.state},{data?.city}
                        </Typography>
                        <div className="mt-1">
                          <Chip
                            label="Fee Waiver"
                            size="small"
                            sx={{
                              background: "rgba(210, 4, 45,0.8)",
                              color: "white",
                            }}
                          />
                        </div>
                      </Grid2>
                      <Grid2 size={4}>
                        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
                          <div
                            style={{
                              width: "70px",
                              height: "70px",
                              background: "black",
                              borderRadius: "50%",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              fontFamily: FontFamily.Nunito,
                              // border: `5px solid ${ThemeColor.BLUE}`,
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: fontSize.h2.large,
                                fontWeight: fontWeight.W700,
                                color: "white",
                              }}
                            >
                              {getInitials(data.name)}
                            </Typography>
                          </div>
                        </div>
                      </Grid2>
                    </Grid2>
                  )}

                  <div
                    className="w-100 mt-4 card-scroll"
                    style={{ height: "65%", overflowY: "scroll" }}
                  >
                    <div>
                      {" "}
                      <Divider sx={{ borderColor: ThemeColor.GREY }} />
                    </div>
                    <Editor
                      style={{ marginBottom: 10 }}
                      editorState={Description(data?.description)}
                      readOnly={true}
                      toolbarHidden
                    />
                  </div>

                  {/* <Button className="mt-4" text="View Profile" variant="contained" sx={{background:ThemeColor.BLUE}}>
                View Profile
              </Button> */}
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Login>
  );
}

export default UniversityCard;
